<template>
  <el-dialog
    :visible.sync="visible"
    width="480px"
    :close-on-click-modal="false"
    :before-close="handleClose"
    append-to-body
    class="party-member-review-dialog"
  >
    <div class="review-title">
      <span class="review-name">{{ name }}</span> 评选结果
    </div>
    <el-form :model="form" label-width="90px" class="review-form">
      <el-form-item label="评选结果">
        <el-radio-group v-model="form.processStatus">
          <el-radio :label="2">通过</el-radio>
          <el-radio :label="0">不通过</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="备注">
        <el-input
          type="textarea"
          v-model="form.remark"
          :rows="4"
          placeholder="非必填"
          maxlength="200"
          show-word-limit
        />
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="handleClose">取消</el-button>
      <el-button type="primary" :loading="loading" @click="handleSubmit">提交</el-button>
    </span>
  </el-dialog>
</template>

<script>
import PartyMember from '@/axios/api/partyMember.js'
export default {
  name: 'PartyMemberReviewDialog',
  props: {
    visible: {
      type: Boolean,
      required: true
    },
    name: {
      type: String,
      default: ''
    },
    declareId: {
      type: [String, Number],
      required: true
    }
  },
  data() {
    return {
      form: {
        processStatus: 2,
        remark: ''
      },
      loading: false
    }
  },
  watch: {
    visible(val) {
      if (val) {
        this.resetForm()
      }
    }
  },
  methods: {
    resetForm() {
      this.form = {
        processStatus: null,
        remark: ''
      }
      this.loading = false
    },
    handleClose() {
      this.$emit('update:visible', false)
    },
    async handleSubmit() {
      if (this.form.processStatus === null) {
        this.$message.warning('请选择评选结果')
        return
      }
      this.loading = true
      try {
        let res = await PartyMember.updateDeclareApplication({ 
          id: this.declareId, 
          processStatus: this.form.processStatus, 
          remark: this.form.remark 
        })
        if (res.status == 1) {
          this.$message.success('提交成功')
          this.$emit('updateList')
          this.handleClose()
        } else {
          this.$message.error('提交失败')
        }
      } catch (e) {
        this.$message.error('提交失败')
      }
    }
  }
}
</script>

<style scoped>
.party-member-review-dialog >>> .el-dialog__body {
  padding: 10px 30px 0 30px;
}
.review-title {
  font-weight: bold;
  font-size: 16px;
  margin-bottom: 18px;
  color: #333;
}
.review-name {
  font-weight: bold;
  font-size: 16px;
  color: #222;
}
.review-form {
  margin-top: 10px;
}
.dialog-footer {
  text-align: center;
  display: flex;
  justify-content: center;
  padding-bottom: 10px;
}
</style>
